module.exports = __webpack_public_path__ + "static/media/jenna-ivory-icon.fe1c27f9.jpg";